export default "__VITE_ASSET__BwFZQUdI__"